import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=640ca65a"
import script from "./UserNotifications.vue?vue&type=script&lang=ts"
export * from "./UserNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports